
//  useQuery

import { useQuery } from "react-query";
import { getManagersApproveRestrictClient, getManagersGrantDiscount, requestTokenManager, validateTokenManager } from "./_request";
import { responseToSelect } from "../utils/responseToSelect";

export const useManagersGrantDiscount = () => {
    return useQuery(
        'managersGrantDiscount',
        getManagersGrantDiscount,
        {
            retry: 0,
            refetchIntervalInBackground: false,
            refetchOnWindowFocus: false,
            initialData: [],
            select: (data) => responseToSelect(data)
        }
    );
};

export const useManagersApproveRestrictClient = () => {
    return useQuery(
        'managersApproveRestrictClient',
        getManagersApproveRestrictClient,
        {
            retry: 0,
            refetchIntervalInBackground: false,
            refetchOnWindowFocus: false,
            initialData: [],
            select: (data) => responseToSelect(data)
        }
    );
};